import { ApplicationConfig, Provider } from "@angular/core";
import { provideRouter, withComponentInputBinding } from "@angular/router";
import { routes } from "./app.routes";

import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { provideEffects } from "@ngrx/effects";
import { EFFECTS } from "./ngrx/effects";
import { META_REDUCERS, REDUCERS } from "./ngrx/reducers";
import { provideStore } from "@ngrx/store";
import { TokenInterceptor } from "./interceptors/token.interceptor";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import { provideTranslateService } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import {
  FrappeApiHelper,
  FrappeConfiguration,
  FrappeCrudService,
  FrappeMethodService,
} from "@aht/frappe-client";

const frappeClientConfiguration = {
  baseUrl: environment.apiUrl,
} as FrappeConfiguration;

const frappeClientLibraryProviders = [
  {
    provide: FrappeCrudService,
    useFactory: (client: HttpClient) =>
      new FrappeCrudService(client, frappeClientConfiguration),
    deps: [HttpClient],
  },
  {
    provide: FrappeMethodService,
    useFactory: (client: HttpClient) =>
      new FrappeMethodService(client, frappeClientConfiguration),
    deps: [HttpClient],
  },
  {
    provide: FrappeApiHelper,
    useFactory: (crud: FrappeCrudService, method: FrappeMethodService) =>
      new FrappeApiHelper(crud, method),
    deps: [FrappeCrudService, FrappeMethodService],
  },
] as Provider[];

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideStore(REDUCERS, {
      runtimeChecks: {
        strictActionImmutability: true,
        strictActionTypeUniqueness: true,
        strictActionWithinNgZone: true,
        strictStateImmutability: true,
      },
      metaReducers: META_REDUCERS,
    }),
    provideEffects(EFFECTS),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideStoreDevtools(),

    provideTranslateService({
      lang: "de",
      fallbackLang: "en",
    }),

    ...frappeClientLibraryProviders,
  ],
};

// export function HttpLoaderFactory(http: HttpClient) {
//   return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
// }
